import { Check } from "lucide-react";
import VideoFassade from "../components/VideoFassade";
import CtaButton from "../components/CtaButton";
import Logo from "../components/Logo";
import { GOOGLE_BEWERTUNGEN, GOOGLE_STERNE } from "../lib/bewertungen";

const LISTE = [
  "Die Zahl Ihrer Entscheider im DACH-Raum, nicht geschätzt, sondern gezählt",
  "Wie aktiv diese Zielgruppe auf LinkedIn ist",
  "Wie viele Entscheidergespräche pro Monat realistisch sind",
  "Ob sich eine Zusammenarbeit für Sie rechnet"
];

export default function Hero() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-6xl px-5 pb-16 pt-10 sm:px-8 sm:pb-24 sm:pt-14">
        <Logo className="h-8 sm:h-9" />
        <div className="mt-12 flex items-center gap-4" data-testid="hero-eyebrow">
          <span className="h-px w-10 bg-navy/40" />
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">
            Für Geschäftsführer mit einer spitzen Entscheider-Zielgruppe
          </p>
        </div>
        <h1
          className="mt-9 max-w-4xl text-4xl font-light leading-[1.12] tracking-[-0.01em] text-textdunkel sm:text-5xl lg:text-[4rem]"
          data-testid="hero-headline"
        >
          4–5 qualifizierte Entscheidertermine im Monat.{" "}
          <span className="font-semibold">Mit unserem LinkedIn-Done-for-you-Entscheidersystem.</span>
        </h1>
        <p className="mt-8 max-w-3xl text-base leading-[1.85] text-textgrau sm:text-lg" data-testid="hero-subheadline">
          In diesem Video zeige ich Ihnen, wie wir für Fonds, Kapitalgeber, Nischen-Industrie und spezialisierte
          Beratungen jeden Monat den Kalender mit Entscheiderterminen füllen.
        </p>
        <div className="mt-12 max-w-3xl">
          <VideoFassade />
        </div>
        <div className="mt-10 flex flex-col items-start">
          <CtaButton testid="cta-hero" />
          <div className="mt-8" data-testid="hero-liste">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau">Das nehmen Sie mit</p>
            <ul className="mt-4 space-y-2.5">
              {LISTE.map((l) => (
                <li key={l} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gruen/10 text-gruen">
                    <Check size={12} strokeWidth={2.5} />
                  </span>
                  <span className="text-sm leading-[1.7] text-textdunkel sm:text-base">{l}</span>
                </li>
              ))}
            </ul>
          </div>
          <p className="mt-7 text-sm text-textgrau" data-testid="hero-termin-hinweis">
            45 Minuten mit Patrick Häfner · kostenfrei · nur nach kurzer Vorab-Prüfung
          </p>
          <div className="mt-8 flex items-center gap-3" data-testid="hero-google-bewertungen">
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
              <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z" />
              <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z" />
              <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
            </svg>
            <p className="text-sm text-textgrau">
              {GOOGLE_STERNE} von 5 Sternen bei {GOOGLE_BEWERTUNGEN} Google-Bewertungen
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
